













































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Tenant from "@/store/entities/tenant";
import WardForSelect from "@/store/entities/wardForSelect";
import AppConsts from "@/lib/appconst";
import Ref from "@/store/entities/ref";
import _ from "lodash";
@Component
export default class CreateTenant extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  tenant: Tenant = new Tenant();
  // districts: DistrictForSelect[] = new Array<DistrictForSelect>();
  wards: WardForSelect[] = new Array<WardForSelect>();
  inboundModes: Ref[] = new Array<Ref>();
  get provinces() {
    return this.$store.state.geoLocation.provincesForSelect;
  }
  getInboundModes(re) {
    this.inboundModes = re;
  }

  save() {
    (this.$refs.tenantForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.tenant.fullAddress = this.getFullAddress();
        await this.$store.dispatch({
          type: "tenant/create",
          data: this.tenant,
        });
        (this.$refs.tenantForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    // this.districts = [];
    this.wards = [];
    (this.$refs.tenantForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
  tenantRule = {
    tenancyName: [
      {
        required: true,
        message: this.L("Error.RequiredField", undefined, this.L("TenantCode")),
        trigger: "blur",
      },
    ],
    name: [
      {
        required: true,
        message: this.L(
          "Error.RequiredField",
          undefined,
          this.L("TenancyName")
        ),
        trigger: "blur",
      },
    ],
    adminEmailAddress: [
      {
        required: true,
        message: this.L(
          "Error.RequiredField",
          undefined,
          this.L("AdminEmailAddress")
        ),
        trigger: "blur",
      },
      { type: "email" },
    ],
    contactPhone: [
      {
        required: true,
        message: this.L(
          "Error.RequiredField",
          undefined,
          this.L("ContactPhone")
        ),
        trigger: "blur",
      },
    ],
    provinceId: [
      {
        required: true,
        type: "number",
        message: this.L("FieldIsRequired", undefined, this.L("Province")),
        trigger: "blur",
      },
    ],
    /* districtId: [
      {
        required: true,
        type: "number",
        message: this.L("FieldIsRequired", undefined, this.L("District")),
        trigger: "blur",
      },
    ], */
    wardId: [
      {
        required: true,
        type: "number",
        message: this.L("FieldIsRequired", undefined, this.L("Ward")),
        trigger: "blur",
      },
    ],
    addressNo: [
      {
        required: true,
        message: this.L("FieldIsRequired", undefined, this.L("AddressNo")),
        trigger: "blur",
      },
    ],
    inboundMode: [
      {
        required: true,
        message: this.L("FieldIsRequired", undefined, this.L("InboundMode")),
        trigger: "blur",
      },
    ],
  };

  async onchangeProvince() {
    if (_.isNil(this.tenant.provinceId) || this.tenant.provinceId <= 0) return;
    this.tenant.wardId = null;
    await this.$store
      .dispatch({
        type: "geoLocation/getWardsForSelectOfProvince",
        data: {
          provinceId: this.tenant.provinceId,
        },
      })
      .then((res) => {
        this.wards = res;
      });
  }

  /* async onchangeDistrict() {
    if (_.isNil(this.tenant.districtId) || this.tenant.districtId <= 0) return;
    await this.$store
      .dispatch({
        type: "geoLocation/getWardsForSelectOfDistrict",
        data: {
          districtId: this.tenant.districtId,
        },
      })
      .then((res) => {
        this.wards = res;
      });
  } */

  getFullAddress() {
    const province = this.provinces.find((p) => p.id == this.tenant.provinceId);
    // const district = this.districts.find((p) => p.id == this.tenant.districtId);
    const ward = this.wards.find((p) => p.id == this.tenant.wardId);
    return Util.buildAddress([
      this.tenant.addressNo,
      _.get(ward, "name"),
      // _.get(district, "name"),
      _.get(province, "name"),
    ]);
  }

  async created() {
    await this.$store.dispatch({
      type: "geoLocation/getProvincesForSelect",
    });
    await this.$store
      .dispatch({
        type: "ref/getRefsForSelect",
        param: {
          tableName: AppConsts.tableRef.tableWh.name,
          columnName: AppConsts.tableRef.tableWh.column.inboundMode,
        },
      })
      .then((res) => {
        this.getInboundModes(res);
      });
  }
}
